<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Job Manager'"></Teranet-PageTitle>
    <form [formGroup]="hangfireJobFormGroup" #addHangfireJob="ngForm" (ngSubmit)="submit(addHangfireJob)" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Hangfire Jobs'" [IconName]="'calendar-plus'"></Teranet-ClientTitle>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Job Name</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required [(value)]="selected" formControlName="jobName" placeholder="--Please Select--">
                    <!--Add Method Names for Hangfire Jobs Here-->
                    <!--Match with HangFireJob.cs in LMSEntityLibrary & HangfireRepository.cs in EnsurexHangfireService-->
                    <mat-option value="CheckSchedule">Check Schedule</mat-option>
                    <mat-option value="GenerateReport">Generate Match Report</mat-option>

                  </mat-select>
                  <mat-error>
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Cron Time</mat-label>
                <mat-form-field appearance="outline">
                  <input required type="text" data-lpignore="true" formControlName="cronTime" matInput />
                  <mat-error>
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="teranet-padding">
                <div class="focus" *ngIf="notReadonly">
                  <h6>
                    Hangfire Jobs are Scheduled as a Cron (* * * * *) Expression<br />
                    *M[inute(0-59)] *H[our(0-23)] *D[ayOfMonth(1-31)] *M[onth(1-12)] *D[ayOfWeek(0-6)]<br />
                    |*| = ANY; |,| = VALUE LIST SEPERATOR; |-| = RANGE; |/| = STEP VALUE<br />
                    Ex. */10 * * * * = Every 10th Minute; 30 15 * * * = At 15:30; */5 17-23 * * * = Every 5th Minute from 17:00 to 23:00
                  </h6>
                </div>
              </div>
            </div>
            <div *ngIf="notReadonly" fxLayout="row wrap" fxLayoutAlign="end">
              <button mat-raised-button class="plain-button-lg" type="reset">Reset</button>
              <button mat-raised-button class="theme-button-lg" type="submit">Add/Update</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="hangfireJobs"
                            [gridName]="'hangfireJobs'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="gridDefaultSettings()"
                            [isFinishLoading]="true"
                            [pageName]="'hangfireJobs'"
                            (onDelete)="delete($event)"></Teranet-CustomizedGrid>
  </div>
</div>
